export const deployment = "production";

const envConfig = {
  //app
  appName: 'Practido',
  appFullName: 'Practido Online Olympiad',
  appEmail: 'hello@practido.com',
  
  //support
  // supportPhone: String(process.env.REACT_APP_SUPPORT_PHONE),
  supportEmail: 'hello@practido.com',

  // social links
  facebookLink: 'https://www.facebook.com/profile.php?id=100094743883639',
  twitterLink: 'https://twitter.com/olympiad_p',
  instagramLink: 'https://www.instagram.com/olympiadpracticeapp?igshid=YzVkODRmOTdmMw%3D%3D',
  youtubeLink: 'https://www.youtube.com/@OlympiadPracticeApp',
  whatsappLink: 'https://whatsapp.com/channel/0029Va50kJ33rZZbb9X3za1q',

  // store links
  // appStoreLink: String(process.env.REACT_APP_APP_STORE_LINK),
  googlePlayLink: 'https://play.google.com/store/apps/details?id=com.naskay.olympiadpractice',

  appUrl:
    deployment === "production"
      ? 'https://practido.com/'
      : deployment === "staging"
        ? 'https://stagingolympiad.naskay.in/'
        : 'http://localhost:3000/',

  // Backeng url - render
  backendUrl:
    deployment === "production"
      ? 'https://practido.com/payment/payment.php'
      : deployment === "staging"
        ? 'https://stagingolympiad.naskay.in/payment/payment.php'
        : 'http://localhost:4000/payment.php',

  ipInfoKey:
    deployment === "production"
      ? String(process.env.REACT_APP_IPINFO_KEY_LOCAL)
      : deployment === "staging"
        ? String(process.env.REACT_APP_IPINFO_KEY_STAGING)
        : String(process.env.REACT_APP_IPINFO_KEY_PRODUCTION),

  examDuration: Number(50),

  questionSheetId: String(process.env.REACT_APP_QUESTIONS_SHEET_ID), //sheets
  fetchQuestionsApi: String(process.env.REACT_APP_FETCH_QUESTIONS), //appscript
  emailApi: String(process.env.REACT_APP_EMAIL_API), //appscript
};

export default envConfig;
